module.exports = __webpack_public_path__ + "static/media/GitHub.3b197f83.svg";